import axios from 'axios';
import type { GetUserVerifiedAddressesResponse } from '@bvengineering/cas-member-gateway-service-client';
import { useApiQuery } from '@/api/hooks/useQuery';
import { addressKeys } from '@/api/queryKeys';

const EMPTY_ADDRESSES: GetUserVerifiedAddressesResponse = { message: '', data: [] };

/**
 * Hook to fetch all verified addresses for the current user.
 * Uses the Api container's settings client.
 * The backend returns 404 when no addresses are saved — treated as an empty list.
 */
export function useVerifiedAddresses() {
  return useApiQuery({
    queryKey: addressKeys.verified(),
    queryFn: (api) => async () => {
      try {
        const response = await api.settings.settingsControllerGetVerifiedAddresses();
        return response.data;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          return EMPTY_ADDRESSES;
        }
        throw err;
      }
    },
  });
}
